import ClientCatalogModel from 'Models/ClientCatalogModel';
import blogStore from 'Root/store/modules/blog';
import searchStore from 'Root/store/modules/search';
import GameModel from 'Models/GameModel';
import { setNotFoundState } from 'Root/helpers/tools';

function setActiveGame(store, route) {
  const game = route.params.gameNamespace
    ? GameModel.ROUTE_TO_DATA[route.params.gameNamespace]
    : null;

  store.commit('blog/mutateActiveGame', game?.id);
}

export default function blog(store) {
  return {
    name: 'blog',
    path: '/blog',

    component: () => import(/* webpackChunkName: 'blog-core' */ '../../pages/blog/BlogCore.vue'),

    beforeEnter(to, from, next) {
      if (!store.hasModule('blog')) {
        const options = {};
        if (store.state.blog) {
          options.preserveState = true;
        }

        store.registerModule('blog', blogStore, options);
      }

      if (!store.hasModule('search')) {
        const options = {};
        if (store.state.search) {
          options.preserveState = true;
        }

        store.registerModule('search', searchStore, options);
      }

      next();
    },

    children: [
      {
        path: '/authors/:authorSlug',
        name: 'blog__author',
        component: () => import('../../pages/blog/blogAuthor/BlogAuthor.vue'),
        meta: {
          isCenteredPage: true,
          shouldUseBg: ClientCatalogModel.BG.NEUTRAL,
        },
        async beforeEnter(to, from, next) {
          await store.dispatch('blog/fetchAuthor', to.params.authorSlug)
            .catch(() => setNotFoundState(store));

          if (from.name !== null) {
            store.commit('blog/pruneArticles');
          }

          next();
        },
      },
      {
        path: ':gameNamespace/articles/:articleSlug',
        name: 'blog__article',
        component: () => import(/* webpackChunkName: 'blog-core' */ '../../pages/blog/blogArticle/BlogArticle.vue'),
        meta: {
          isCenteredPage: true,
          shouldUseBg: ClientCatalogModel.BG.NEUTRAL,
        },
        beforeEnter(to, from, next) {
          setActiveGame(store, to);
          next();
        },
      },
      {
        path: ':gameNamespace?/:categorySlug?',
        name: 'blog__root',
        component: () => import(/* webpackChunkName: 'blog-core' */ '../../pages/blog/blogMain/BlogMain.vue'),
        meta: {
          isCenteredPage: true,
          shouldUseBg: ClientCatalogModel.BG.NEUTRAL,
        },
        beforeEnter(to, from, next) {
          setActiveGame(store, to);
          next();
        },
      },
    ],
  };
}
